import { createAsyncCollectionStateWithPreloadHook } from '@lib/hooks';

import { notificationsActions, SonarNotification } from '@sonar-software/sonar-notifications';

const empty: Array<SonarNotification> = [];

export const useNotifications = createAsyncCollectionStateWithPreloadHook({
	loadAction: notificationsActions.requestGetNotifications,
	selector: (state) => state.notifications.get,
	useTransform: (result) => result.data || empty
});
